import React from 'react'
import styled from 'styled-components'
import { Text } from '@olxbr/design-system'

const errorMsg = styled(Text)`
  font-size: 12px !important;
  color: #ff4444;
`

export default errorMsg
